// import { appController } from "@app/model/mc/app/AppController";
import { appController } from "@app/model";
import { Dispatcher, indexedDbUtils, teamGroupMap } from "@fanfanlo";
import { env } from "@src/confs/env";
import { matrixInit } from "@src/im/client";
import getConfig from "next/config";
import { mainModel } from "./MainModel";

export class MainController extends Dispatcher{
    

    /**
     * 加载对应的配置文件并存入 mainModel.appConfig
     */
    async loadAppConfigFile() {
        const conf = getConfig();
        const { env, region } = conf?.publicRuntimeConfig || {};
        const configUrl = `/configurations/main.${env}.${region}.json`;
        const res = await fetch(configUrl);
        if (!res.ok) throw new Error(`加载配置失败: ${configUrl}`);
        mainModel.appConfig = await res.json();
        console.log('mainModel.appConfig', mainModel.appConfig);
    }

    async init(){
        await this.loadAppConfigFile();
        const conf = getConfig();
        await this.start();
    }
    async start(){
        teamGroupMap.def.gateway = env.gateway;
        matrixInit.init();
        await indexedDbUtils.init()
        await appController.init()
        
    }
}

export const mainController = new MainController()